import { Deal } from "../../models/shared/Deal";

export const isDealSeparator = (deal: Deal) => {
    const dealName = deal.name || '';
    return dealName.match(/^[-_]+$/);
}

export const getActiveDealsCount = (deals: Deal[]) => {
    return deals.filter(deal => !isDealSeparator(deal)).length;
}
